import type { HTMLAttributes } from 'react'
import { forwardRef } from 'react'
import { cx } from 'src/utils/cx'

/**
 * A visually expandable box
 *
 * Supported data attributes:
 *  - `data-expanded`: Whether the box is expanded
 *
 * Supported CSS variables:
 *  - `--extent`: The padding extent for the expansion effect (as a CSS size)
 */
export default forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function ExpandableBox({ children, ...props }, ref) {
    return (
      <div
        ref={ref}
        {...props}
        className={cx(
          'grid grid-cols-1 grid-rows-1 place-items-center overflow-hidden box-content data-[expanded]:p-[--extent] data-[expanded]:-m-[--extent] transition-all duration-150 ease-out',
          props.className,
        )}
        style={props.style}
      >
        <div className="size-[calc(100%+var(--extent)*2)]">{children}</div>
      </div>
    )
  },
)
